import { forwardRef } from 'react';
import { Box, Checkbox, CheckboxProps, SxProps } from '@mui/material';

import { checkboxSx } from '@/components/checkbox/styled';
import Icon from '@/components/icon/icon';

const checkedIcon = (
  <Box
    sx={{
      alignItems: 'center',
      bgcolor: '#fff',
      border: '1px solid #4563b3',
      borderRadius: '4px',
      color: '#4563b3',
      display: 'flex',
      height: '16px',
      justifyContent: 'center',
      p: '2px',
      width: '16px',
    }}
  >
    <Icon height={12} id="icon-check" width={12} />
  </Box>
);

const icon = (
  <Box
    sx={{
      bgcolor: '#fff',
      border: '1px solid #d6d6d6',
      borderRadius: '4px',
      height: '16px',
      width: '16px',
    }}
  />
);

const indeterminateIcon = (
  <Box
    sx={{
      alignItems: 'center',
      bgcolor: '#fff',
      border: '1px solid #4563b3',
      borderRadius: '4px',
      color: '#4563b3',
      display: 'flex',
      height: '16px',
      justifyContent: 'center',
      p: '2px',
      width: '16px',
    }}
  >
    <Icon height={12} id="icon-minus" width={12} />
  </Box>
);

interface CustomCheckboxProps extends CheckboxProps {
  sx?: SxProps;
}

const CustomCheckbox = forwardRef<HTMLButtonElement, CustomCheckboxProps>(
  ({ sx = {}, ...rest }, ref) => {
    return (
      <Checkbox
        ref={ref}
        {...rest}
        checkedIcon={checkedIcon}
        icon={icon}
        indeterminateIcon={indeterminateIcon}
        sx={{
          ...checkboxSx,
          ...sx,
        }}
      />
    );
  },
);

export default CustomCheckbox;
